<template>
  <span
    class="fs-12 color-slaty zIndex9999 tr w100 color-teal-secondary medium"
    v-if="skipText?.length > 0"
    @click="handleSkipCTA"
    >{{ skipText }}
    <i class="hkfi-arrow-line fs-10 ml3 color-teal-secondary medium"></i
  ></span>
</template>

<script>
import Utility from "../helpers/utility";
import { LoginStates } from "../helpers/loginStateConstants";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_CLICK_LOGIN_SKIP,
} from "../helpers/analyticsEvents";
export default {
  name: "SkipLogin",
  components: {},
  props: ["moduleProps", "skipText"],
  data() {
    return { modulePropsData: {} };
  },
  mounted() {
    // this.modulePropsData =
    //   typeof this.moduleProps != null &&
    //   typeof this.moduleProps != "null" &&
    //   typeof this.moduleProps != "undefined"
    //     ? JSON.parse(this.moduleProps)
    //     : {};
  },
  methods: {
    handleSkipCTA(e) {
      EVENT_CLICK_LOGIN_SKIP()
      LocalStorageFunc.setSessionStorageKey("LOGIN_FLOW_SKIP", true);
      Utility.redirectToHomeOrRedirectUrl();
    },
  },
  computed: {
    // skipText() {
    //   // @todo skipText will vary based on redirect url
    //   if (Utility.isRedirectedFromCart()) {
    //     return "";
    //   }
    //   return "Skip";
    // },
    // isOtpVerification() {
    //   return (
    //     this.$store.state.Auth.currentLoginState === LoginStates.otpVerification
    //   );
    // },
  },
};
</script>
